import React, { useState } from "react";

import PageLoading from "components/PageLoading";

import WidgetHeader from "./../WidgetHeader";
import TimeseriesPlotly from "./TimeseriesPlotly";

const Timeseries = ({ tagData, isDefaultDashboard, onWidgetAction, isWidgetUpdating }) => {
  const getWidgetDesc = () => `${tagData.TagId} | ${tagData.Description || ""}`;
  const getTagDuration = () => tagData.ExtraData || "";
  const getTagUnits = () => tagData.TagUnits || "";
  const [error, setError] = useState(false);

  return (
    <div className={`cardContainer timeSeries__cardContainer ${error ? "card-error" : ""}`}>
      {isWidgetUpdating ? (
        <PageLoading customHeight="100%" />
      ) : (
        <>
          <WidgetHeader
            title={tagData.TagName}
            units={getTagUnits()}
            duration={getTagDuration()}
            WidgetID={tagData.Id}
            description={getWidgetDesc()}
            onWidgetAction={onWidgetAction}
          />
          <TimeseriesPlotly tagData={tagData} setError={setError} />
        </>
      )}
    </div>
  );
};

export default Timeseries;
